import { getIssuePriority } from 'pages/Desk/issues/shared';
import { memo } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';

type PriorityLozengeProps = Readonly<{
    priority: number;
}>;

function PriorityLozenge({ priority }: PriorityLozengeProps) {
    const { label, backgroundColor, textColor } = getIssuePriority(priority);
    const upperLabel = label.toUpperCase();

    return (
        <Lozenge color={textColor} backgroundColor={backgroundColor}>
            {upperLabel}
        </Lozenge>
    );
}

const memoPriorityLozenge = memo(PriorityLozenge);
export { memoPriorityLozenge as PriorityLozenge };
